import React from "react";
import PropTypes from "prop-types";
import styles from "components/manage-envelopes/envelope-modals.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const RequestEnvelopeModal = ({
  accountId,
  isRequestEnvelopeVisible,
  onHideRequestEnvelope,
  onRequestEnvelope
}) => (
  <Modal
    isVisible={ isRequestEnvelopeVisible }
    onClose={ onHideRequestEnvelope }
    transitionName="request-envelope"
  >
    <h2>Need an extra Magic Envelope?</h2>
    <div className={ styles.controls }>
      <Button link onClick={ onHideRequestEnvelope }>close</Button>
      <Button onClick={ () => onRequestEnvelope(accountId) } primary>Request Envelope</Button>
    </div>
  </Modal>
);

RequestEnvelopeModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  isRequestEnvelopeVisible: PropTypes.bool.isRequired,
  onHideRequestEnvelope: PropTypes.func.isRequired,
  onRequestEnvelope: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/manage-envelopes/request-envelope-modal.jsx